import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Link, matchPath, useLocation } from 'react-router-dom';
import { Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SelectableItem } from 'src/shared/models/gui/selectableItem';

const useRouteMatch = (patterns: readonly string[]) => {
  const { pathname } = useLocation();

  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i];
    const possibleMatch = matchPath(pattern, pathname);
    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }

  return null;
};

type DistrictPageTabNavigationProps = {
  tabs: SelectableItem[];
};

export default function DistrictPageTabNavigation(props: DistrictPageTabNavigationProps) {
  const { tabs } = props;
  const { t } = useTranslation(['common']);
  const routeMatch = useRouteMatch(tabs.map((x) => x.value)); // Order is important here, read documentation on MUI
  const currentTab = routeMatch?.pattern?.path;

  return (
    <>
      <Tabs value={currentTab} allowScrollButtonsMobile variant='scrollable'>
        {tabs.map((item) => (
          <Tab label={t(item.label)} key={item.value} value={item.value} to={item.value} component={Link as any} />
        ))}
      </Tabs>
      <Divider />
    </>
  );
}
